import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TdLoadingService, TdDigitsPipe, TdDialogService, ITdDataTableColumn, TdMediaService, TdDataTableService } from '@covalent/core';
import { MdDialog, MdSnackBar, MdSelect } from '@angular/material';
import { HojaDeConsulta } from '../../models';

import { HojaDeConsultaService, LoginService } from '../../services';

import { HojaDeConsultaDetalleComponent } from './detallehojadeconsulta/detallehojadeconsulta.component';

@Component({
    selector: 'qs-hojadeconsulta',
    templateUrl: './hojadeconsulta.component.html',
    styleUrls: ['./hojadeconsulta.component.scss'],
    viewProviders: [HojaDeConsultaService],
})
export class HojaDeConsultaComponent implements AfterViewInit {

    title: string;
    consultas: HojaDeConsulta[];
    filteredData: HojaDeConsulta[] = [];
    fecha: Date;
    profesional: any;
    esp: string;
    esppr: string;

    filtroPendientes: boolean = false;
    filtroAgenda: string;
    es: any;

    constructor(private _titleService: Title,
        private _hojaDeConsultaService: HojaDeConsultaService,
        private _loadingService: TdLoadingService,
        private _dialogService: TdDialogService,
        private _loginService: LoginService,
        public media: TdMediaService,
        public dialog: MdDialog,
        public snackBar: MdSnackBar,
        private _router: Router,
        private _changeDetectorRef: ChangeDetectorRef) {

            this.es = {
                firstDayOfWeek: 1,
                dayNames: [ 'domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado' ],
                dayNamesShort: [ 'dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb' ],
                dayNamesMin: [ 'D', 'L', 'M', 'X', 'J', 'V', 'S' ],
                monthNames: [ 'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre' ],
                monthNamesShort: [ 'ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic' ],
                today: 'Hoy',
                clear: 'Borrar',
            };
        }

    ngAfterViewInit(): void {
        this.media.broadcast();
        this._titleService.setTitle('Hoja de consulta');
        this.title = this._titleService.getTitle();
        this._loadingService.register('consultas.load');
        this.profesional = this._loginService.profesional;
        this.filtroAgenda = this.profesional.TipoMedico.tipoMedico[0].Agenda + '@'
            + this.profesional.TipoMedico.tipoMedico[0].Centro + '@' +
            this.profesional.TipoMedico.tipoMedico[0].Esp + '@' +
            this.profesional.TipoMedico.tipoMedico[0].EspPR + '@' +
            this.profesional.TipoMedico.tipoMedico[0].Colegiado + '@' +
            this.profesional.TipoMedico.tipoMedico[0].Cias;
        this.esp = this.profesional.TipoMedico.tipoMedico[0].Esp;
        this.esppr = this.profesional.TipoMedico.tipoMedico[0].EspPR;
        this._loginService.colegiado = this.profesional.TipoMedico.tipoMedico[0].Colegiado;
        this._loginService.cias = this.profesional.TipoMedico.tipoMedico[0].Cias;
        this._loginService.agenda = this.profesional.TipoMedico.tipoMedico[0].Agenda;
        this.fecha = this._loginService.fechaHojaConsulta || new Date();
        let fecha: string = this.fecha.getDate() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getFullYear();
        this._hojaDeConsultaService.obtenerHojaDeConsulta(
            this.profesional.TipoMedico.tipoMedico[0].Centro,
            fecha,
            this.profesional.TipoMedico.tipoMedico[0].Agenda).subscribe((consultas: any) => {
                this.consultas = consultas.respuesta;
                this.filteredData = this.consultas;
                this._loadingService.resolve('consultas.load');
            }, (error: Error) => {
                this._loadingService.resolve('consultas.load');
            });
        this._changeDetectorRef.detectChanges();
    }

    filter(): void {
        this._loadingService.register('consultas.filter');
        this.filteredData = [];
        let fecha: string = this.fecha.getDate() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getFullYear();
        let agendaCentro: string[] = this.filtroAgenda.split('@');
        this._loginService.agenda = agendaCentro[0];
        this._loginService.colegiado = agendaCentro[4];
        this._loginService.cias = agendaCentro[5];
        this.esp = agendaCentro[2];
        this.esppr = agendaCentro[3];
        this._hojaDeConsultaService.obtenerHojaDeConsulta(
            agendaCentro[1],
            fecha,
            agendaCentro[0]).subscribe((consultas: any) => {
                this.consultas = consultas.respuesta;
                this.filteredData = this.consultas;
                this._loadingService.resolve('consultas.filter');
            }, (error: Error) => {
                this._loadingService.resolve('consultas.filter');
            });
    }

    filterAusentes(): void {
        if (this.consultas !== undefined) {
            this._loadingService.register('consultas.filter');
            this.filteredData = [];
            if (this.filtroPendientes) {
                this.filteredData = this.consultas.filter((consulta: HojaDeConsulta): boolean => { return (consulta.presente); });
            } else {
                this.filteredData = this.consultas;
            }
            setTimeout(() => {
                this._loadingService.resolve('consultas.filter');
            }, 200);
        }
    }

    updateDate(date: Date): void {
        this.fecha = date;
        this._loginService.fechaHojaConsulta = this.fecha;
        this.filter();
    }

    /**
     * Abre una vista detalle de la consulta
     * @param consulta
     */
    openDetalle(consulta: any): void {
        let dialogRef: any = this._dialogService.open(HojaDeConsultaDetalleComponent, {
            data: consulta,
            width: '60%',
            role: 'dialog',
        });
        dialogRef.componentInstance.consulta = consulta;
    }

    openConsulta(consulta: HojaDeConsulta): void {
        this._loadingService.register();
        if (consulta.visita === '') {

            /*this._hojaDeConsultaService.agregarDatosAdministrativos(
                consulta.numeroExpediente
                    ).subscribe((respuesta: any) => {
                            this._loginService.consulta.sexo = respuesta.respuesta.sexo;
                            this._loginService.consulta.fechaNacimiento = respuesta.respuesta.fechaNacimiento;
                            this._loginService.consulta.dni = respuesta.respuesta.dni;
                }, (error: Error) => {
            });*/

            this._hojaDeConsultaService.comprobarVisita(
                consulta.numeroExpediente,
                this._loginService.profesional.Dni,
                consulta.cita,
                this.esp,
                this.esppr,
            ).subscribe((visita: any) => {
                consulta.visita = visita.respuesta;
                this._loginService.consulta = consulta;
                this._router.navigate(['main/consulta', consulta.numeroExpediente]);
                this._loadingService.resolve();
            }, (error: Error) => {
                this._loadingService.resolve();
            });
        } else {
            this._loginService.consulta = consulta;
            this._loadingService.resolve();
            this._router.navigate(['main/consulta', consulta.numeroExpediente]);
        }

    }

    setConsultaPresente(consulta: HojaDeConsulta): void {
        let message: string = 'Consulta actualizada';
        let errorMessage: string = 'Error actualizando consulta';
        let action: string = 'OK';
        this._hojaDeConsultaService.actualizarEstado(
            this._loginService.profesional.Dni,
            consulta.cita,
            consulta.presente,
        ).subscribe((presente: any) => {
            consulta.presente = presente.respuesta;
            this._loginService.mostrarMensaje(message, action, 2000);
        }, (error: Error) => {
            this._loginService.mostrarMensaje(errorMessage, action, 2000);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/hojadeconsulta/hojadeconsulta.component.ts